import LogoLoop from "src/components/animation/logo-loop"
import Button from "src/components/button"
import companyLogoData from "src/data/company-logo-data.json"
import PillarsCard from "./components/pillars-card"
import CoreCapabilites from "./components/core-capabilites"
import { RevealText } from "src/components/animation/reveal-text"
import ImageLazyLoad from "src/components/image-lazy-load"
import { useRef } from "react"

function Homepage(){
    let width = window.innerWidth;
    let height = window.innerHeight;
    const coreCapabilitesRef = useRef(null)

    return(
        <div className="pt-[139px]">
            <div id="headline" className="flex flex-col lg:flex-row justify-between items-center mx-[24px] sm:mx-[80px] md:mx-[120px] xl:mx-[240px] my-[48px]">
                <div className="flex flex-col gap-[16px]">
                    <RevealText className="text-[32px] lg:text-[48px] font-bold text-left leading-[36px] lg:leading-[50px]">
                        The Perfect <span className="font-lora font-medium italic">Harmony</span><br/>
                        of Advanced Software and<br/>
                        Intelligent Software.<br/>
                    </RevealText>
                    <RevealText className="text-grey text-left">Bridging high-performance custom engineering with systematic cyber defense.</RevealText>
                    <div className="flex flex-row gap-[16px]">
                        <Button onClick={() => {coreCapabilitesRef.current.scrollIntoView()}} color="yellow">Explore Our Capabilities →</Button>
                        <Button to={'/contact-us'} color="white">Connect With Our Team ↗</Button>
                    </div>
                </div>
                <div className="relative hidden lg:block">
                    <img className="absolute right-0 animate-float-enhanced-a" src="/icons/star-1.svg"></img>
                    <img className="absolute bottom-0 animate-float-enhanced-b" src="/icons/star-2.svg"></img>
                    <ImageLazyLoad className="w-[306px] h-[459px]" src="/images/homepage-headline.webp"></ImageLazyLoad>
                </div>
            </div>
            <hr></hr>
            <div className="my-[72px] lg:my-[96px] flex flex-col gap-[18px]">
                <div className="px-[24px] lg:px-0">
                    <p className="text-[24px] lg:text-[32px] font-semibold "><span className="font-lora font-medium italic">Trusted</span> by companies we love working with</p>
                    <p className="text-grey">We don't just deliver services—we join forces with amazing teams to build scalable systems, protect critical assets, and solve complex technical challenges together.</p>
                </div>
                <LogoLoop
                    logos={companyLogoData}
                    speed={25}
                    direction="left"
                    logoHeight={width > 600 ? 90 : 80}
                    gap={width > 600 ? 100 : 50} 
                    pauseOnHover
                    scaleOnHover
                    fadeOut
                    fadeOutColor="#000000000"
                />
            </div>
            <hr></hr>
            <div className="my-[72px] lg:my-[96px] flex flex-col gap-[48px]">
                <div className="px-[24px] lg:px-0">
                    <p className="text-[24px] lg:text-[32px] font-semibold ">An <span className="font-lora font-medium italic">Engineering Ally </span> for Teams that Scale</p>
                    <p className="text-grey">A specialized technology partner blending high-performance software engineering with proactive cyber security.</p>
                </div>
                <PillarsCard/>
            </div>
            <div ref={coreCapabilitesRef} className="py-[72px] lg:py-[96px] mx-[24px] flex flex-col gap-[48px] bg-black text-white rounded-[16px] justify-center items-center">
                <div>
                    <p id="core-capabilities" className="text-[24px] lg:text-[32px] font-semibold ">Core <span className="font-lora font-medium italic">Capabilities</span></p>
                    <p className="text-darkenWhite">Architecting resilient systems. Defending critical assets.</p>
                </div>
                <CoreCapabilites/>
            </div>
            <div className="px-[24px] xl:px-[18px] py-[72px] lg:py-[96px] flex flex-col xl:flex-row justify-center items-center gap-[48px]">
                <div className="text-left flex flex-col justify-left items-left gap-[18px] md:gap-[24px]">
                    <div>
                        <p className="text-[24px] lg:text-[32px] font-semibold ">Transform Your Customer Experience with <span className="font-lora font-medium italic">Orqestra</span></p>
                        <p className="text-grey">Manage your WhatsApp and Instagram interactions seamlessly from a single dashboard.</p>
                    </div>
                    <Button onClick={() => window.location.href='https://orqestra.id/'} color={"black"}>Explore More</Button>
                </div>
                <div className="group relative w-full max-w-[654px] aspect-[654/494]">
                    <div className="absolute w-full h-full bg-black rounded-[8px]">
                        <img className="w-full h-full object-cover rounded-[8px] opacity-0 mix-blend-multiply ease-in-out transition-all duration-500 rotate-30 group-hover:opacity-100 group-hover:mix-blend-normal group-hover:rotate-0" src={"/images/hover-background.webp"}/>
                    </div>
                    <img className="absolute w-[92.5%] max-w-[605px] aspect-[605/445] object-cover object-left left-[7.6%] top-[10.1%] rounded-[8px]" src={"/images/orqestra-dashboard.png"} />
                </div>
            </div>
            <hr></hr>
            <div className="px-[24px] lg:px-0 relative py-[128px] flex flex-col gap-[24px] justify-center items-center text-center">
                <h1 className="text-[32px] lg:text-[48px] font-bold leading-[36px] lg:leading-[50px]">Bring true <span className="font-lora font-medium italic">Harmony</span><br/>
                to your digital infrastructure.</h1>
                <Button to={"/contact-us"} onClick={() => {}} color={"black"}>Get Started</Button>
                <img className="absolute right-16 top-8 lg:top-10 animate-float-enhanced-a" src="/icons/star-1.svg"></img>
                <img className="absolute left-16 bottom-8 lg:bottom-10 animate-float-enhanced-b" src="/icons/star-2.svg"></img>
            </div>
        </div>
    )
}

export default Homepage